module.exports = __webpack_public_path__ + "static/img/title-pt.5e871ac8.webp";